export default __webpack_public_path__ + "static/media/exp-bdemr.b7f634fc.png";